export default __webpack_public_path__ + "pgnv-assets/0a8f6281047c1819867ebdf872b4f2e3.png";